export default __webpack_public_path__ + "static/media/cp_geo_rs.53126246.svg";